/**
 * Module dependencies.
 */

import { CardLink } from 'src/components/core/cards/card-link';
import { Carousel, Slide } from 'src/components/core/carousel';
import { Grid, SubGrid } from 'src/components/core/layout/grid-content';
import { Heading } from 'src/components/core/heading';
import { Section } from 'src/components/core/layout/section';
import { textStyles } from 'src/components/core/text';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  data: Array<{
    href: string;
    title: string;
  }>;
};

/**
 * `StyledCardLink` styled component.
 */

const StyledCardLink = styled(CardLink)`
  ${textStyles.titleM}

  color: var(--color-slate50);
  font-weight: 600;
  min-height: 92px;
`;

/**
 * Export `MorePagesSection` component.
 */

export const MorePagesSection = ({ className, data }: Props) => {
  const { t } = useTranslation();

  return (
    <Section className={className} style={{ paddingTop: 'var(--space-xs)' }}>
      <Grid>
        <SubGrid>
          <Heading asTitle={'h3'} offset shouldAnimate={false} title={t('common:labels.morePages')} titleSize={22} />
        </SubGrid>
      </Grid>

      <Grid data-has-offset-gutter>
        <SubGrid style={{ minWidth: 0 }}>
          <Carousel pagination={{ clickable: true }}>
            {data?.map(({ href, title }) => (
              <Slide key={title}>
                <StyledCardLink href={href} key={href}>
                  {title}
                </StyledCardLink>
              </Slide>
            ))}
          </Carousel>
        </SubGrid>
      </Grid>
    </Section>
  );
};
